'use strict';

// Export a function called trapFocus that limits focus inside a given DOM element
export const trapFocus = function (element) {
    // Define CSS selectors for focusable elements (excluding disabled or hidden ones)
    const focusableSelectors = `
        a[href]:not([disabled]),
        button:not([disabled]):not([tabindex="-1"]),
        textarea:not([disabled]),
        input:not([disabled]),
        select:not([disabled]),
        [tabindex]:not([tabindex="-1"])
    `;

    // Get all visible focusable elements inside the target element
    let focusableEls = Array.from(element.querySelectorAll(focusableSelectors)).filter(el => el.offsetParent !== null);

    // If no focusable elements found, exit the function
    if (focusableEls.length === 0) return;

    // Identify the first and last focusable elements
    let firstEl = focusableEls[0];
    let lastEl = focusableEls[focusableEls.length - 1];

    // Listen for keyboard navigation inside the element
    element.addEventListener('keydown', function (e) {
        // Only react to Tab key
        if (e.key !== 'Tab') return;

        // If Shift + Tab is pressed (backward navigation)
        if (e.shiftKey) {
            // If focus is on the first element, move it to the last
            if (document.activeElement === firstEl) {
                lastEl.focus();
                e.preventDefault(); // Prevent default tabbing behavior
            }
        } else {
            // If focus is on the last element, move it to the first
            if (document.activeElement === lastEl) {
                firstEl.focus();
                e.preventDefault(); // Prevent default tabbing behavior
            }
        }
    });
};
